module.exports = __webpack_public_path__ + "static/d51294c6-516d-4106-907c-0bb49309fadb-5d1b1b2d782ed385667ba2c22a47b1f6.webp";